module.exports = __webpack_public_path__ + "assets/word_smart_report.b69e34c6.svg";